/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, useMediaQuery } from "@mui/material";
import { StyleSheet, css } from "aphrodite";
import { Helmet } from "react-helmet";
import Attendance from "./Attendance/Attendance";
import FriendToMemberTrend from "./FriendToMember/FriendToMemberTrend";
import Counter from "./Counter/Counter";
import SubscriptionCounter from "./Counter/SubscriptionCounter";
import BsgVision from "./BsgVision/BsgVision";
import Glimpse from "./Glimpse/Glimpse";
import NotificationSummaryCard, {
  useNotificationSummaryData,
} from "./NotificationSummaryCard/NotificationSummaryCard";
import { selectUserProfile } from "../../redux/selectors/user";
import Loader from "../../components/common/Loader/Loader";
import LeadershipSummary from "./LeadershipSummary/LeadershipSummary";
import MembershipSummary from "./MembershipSummary/MembershipSummary";
import NewFriendsTrend from "./NewFriendsTrend/NewFriendsTrend";
import OrganizationStatistics from "./OrganizationStatistics/OrganizationStatistics";
import MembershipByDivision from "./MembershipByDivision/MembershipByDivision";
import GohonzonMembers from "./GohonzonMembers/GohonzonMembers";
import DashboardAPI from "../../services/api/dashboard";
import DashboardDisable from "./components/DashboardDisable";
// import LecturersGoshoStudy from "./LecturersGoshoStudy/LecturersGoshoStudy";
// import { PERMISSIONS } from "../../contants";
// import useUserConfig from "../../hooks/useUserConfig";

function Dashboard() {
  const TITLE = "Dashboard - BSG";
  const user = useSelector(selectUserProfile);
  const isMobile = useMediaQuery("(max-width:600px)");
  const notificationItems = useNotificationSummaryData();
  const allowedRoles = ["Area", "Zone", "Region", "Chapter", "District"];
  const positionRole = localStorage.getItem("positionRole");
  // const hasPermission = useUserConfig();

  const [dashboardSetting, setDashboardSetting] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await DashboardAPI.dashboardSetting();
        setDashboardSetting(response?.data || []);
      } catch (err) {
        console.error("Failed to fetch dashboard settings", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const styles = StyleSheet.create({
    containerStyles: {
      minHeight: "100vh",
      background: "#0b2c8acc",
      padding: "10px 10px 0px 10px",
      boxSizing: "border-box",
      "@media (max-width: 768px)": {
        padding: "16px",
      },
    },
    cardWrapper: {
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      borderRadius: "20px",
      padding: "10px",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s ease",
      overflow: "hidden",
      marginBottom: "10px",
      ":hover": {
        transform: "translateY(-8px)",
        boxShadow: "0 30px 60px rgba(0, 0, 0, 0.15)",
      },
      "@media (max-width: 768px)": {
        padding: "16px",
        borderRadius: "16px",
        marginBottom: "16px",
      },
    },
    splitGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "60% 40%",
      gap: "10px",
      alignItems: "stretch",
      marginBottom: "10px",
      marginRight: "10px",
      "@media (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gap: "16px",
      },
    },
    bottomGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
      gap: "24px",
      "@media (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gap: "16px",
      },
    },
  });

  if (loading || !user) return <Loader />;

  // ✅ Check dashboard flag
  const dashboardFlag = dashboardSetting?.find(
    (item) => item.key === "dashboard"
  )?.value;
  const dashboardMsg = dashboardSetting?.find(
    (item) => item.key === "dashboard_msg"
  )?.value;

  if (dashboardFlag === "true") {
    // Show the "Attendance Freezing" page
    // return <Box className={css(styles.messageBox)}>{dashboardMsg || " "}</Box>;
    return <DashboardDisable message={dashboardMsg} />;
  }

  return user ? (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box className={css(styles.containerStyles)}>
        {/* Top Counter always full width */}
        {/* ✅ Lecturers' Gosho Study — Desktop only + Permission check */}
        {/* {hasPermission(PERMISSIONS.LEADERS_VIDEO_VIEW) && (
      <Box
        className={css(styles.cardWrapper)}
        sx={{ padding: "0 !important", overflow: "hidden" }}
      >
        <LecturersGoshoStudy />
      </Box>
    )} */}
        <Box className={css(styles.cardWrapper)}>
          <BsgVision />
        </Box>

        {/* Mobile View - Custom Ordering */}
        {isMobile ? (
          <>
            {/* 1st - Counter ← YEH MISSING THA */}
            <Box className={css(styles.cardWrapper)}>
              <Counter />
            </Box>

            {/* 2nd - Glimpse */}
            <Box
              className={css(styles.cardWrapper)}
              style={{ height: "fit-content" }}
            >
              <Glimpse />
            </Box>

            {/* 3rd - NotificationSummaryCard */}
            {allowedRoles.includes(positionRole) && (
              <Box className={css(styles.cardWrapper)}>
                <NotificationSummaryCard items={notificationItems} />
              </Box>
            )}

            {/* 4th - SubscriptionCounter */}
            <Box className={css(styles.cardWrapper)}>
              <SubscriptionCounter />
            </Box>

            {/* 5th - Attendance */}
            <Box
              className={css(styles.cardWrapper)}
              style={{ height: "fit-content" }}
            >
              <Attendance />
            </Box>

            {/* 6th - FriendToMemberTrend */}
            <Box
              className={css(styles.cardWrapper)}
              style={{ height: "fit-content" }}
            >
              <FriendToMemberTrend />
            </Box>

            <Box
              className={css(styles.cardWrapper)}
              style={{ height: "fit-content" }}
            >
              <NewFriendsTrend />
            </Box>

            <Box
              className={css(styles.cardWrapper)}
              style={{ height: "fit-content" }}
            >
              <OrganizationStatistics />
            </Box>

            <Box className={css(styles.cardWrapper)}>
              <LeadershipSummary />
            </Box>

            <Box className={css(styles.cardWrapper)}>
              <MembershipSummary />
            </Box>

            <Box className={css(styles.cardWrapper)}>
              <MembershipByDivision />
            </Box>

            <Box className={css(styles.cardWrapper)}>
              <GohonzonMembers />
            </Box>
          </>
        ) : (
          /* Desktop View - Original Layout */
          <div className={css(styles.splitGrid)}>
            <Box>
              <Counter />
              <Box
                className={css(styles.cardWrapper)}
                style={{ height: "fit-content" }}
              >
                <Glimpse />
                {/* <Attendance />
                <FriendToMemberTrend /> */}
                <NewFriendsTrend />
                <MembershipByDivision />
                <OrganizationStatistics />
              </Box>
            </Box>
            <Box className={css(styles.cardWrapper)}>
              {allowedRoles.includes(positionRole) && (
                <NotificationSummaryCard items={notificationItems} />
              )}
              <SubscriptionCounter />
              <LeadershipSummary />
              <MembershipSummary />
              <GohonzonMembers />
            </Box>
          </div>
        )}
      </Box>
    </>
  ) : (
    <Loader />
  );
}

export default Dashboard;
